import React, { useState, useEffect, useRef, useMemo } from 'react';
import { DolarSIcon } from '../../components/Icons';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../components/Loader';
import { Form, FormControl, InputGroup } from 'react-bootstrap';
import { PROFILE, SETTINGS_FINANCIAL, SINGLE_POST } from '../../constants/routes';
import { useFormik } from 'formik';
import formik from './AddPostForm';
import FileUpload from './FileUpload';
import { isImage } from '../../helpers';
import { selectAuthUser } from '../../reducers/auth/auth.selectors';
import ModelSubscription from '../../components/ModelSubscription';
import ButtonComponent from 'components/generic-components/ButtonComponent';
import { ROOT } from 'constants/routes';

const AddPost = () => {
  const { t } = useTranslation();
  const user = useSelector(selectAuthUser);
  const dispatch = useDispatch();
  const ref = useRef(null);
  const history = useHistory();
  const [lineValues, setvalue] = useState('');
  const [rows, setrows] = useState(2);
  const [minRows, setminRows] = useState(1);
  const [maxRows, setmaxRows] = useState(6);
  const {
    values,
    status,
    handleSubmit,
    errors,
    touched,
    handleChange,
    isSubmitting,
    setFieldValue,
    setStatus,
    resetForm,
  } = useFormik(formik({ dispatch, history }));

  const handleFileInputChange = files => {

    setFieldValue('files', [
      ...values.files,
      ...files.map(el => ({ file: el, image: isImage(el.name) ? URL.createObjectURL(el) : false })),
    ]);
  };

  const emptyInput = lineValues.trim().length === 0;
  const typingDirection = useMemo(() => {
   return emptyInput ? '' : 'auto';
   },[emptyInput]);

  const handleLineChange = (event) => {
    const textareaLineHeight = 10;


    const previousRows = event.target.rows;
    event.target.rows = minRows;
    // reset number of rows in textarea 

    const currentRows = ~~(event.target.scrollHeight / textareaLineHeight);

    if (currentRows === previousRows) {
      event.target.rows = currentRows;
    }

    if (currentRows >= maxRows) {
      event.target.rows = maxRows;
      event.target.scrollTop = event.target.scrollHeight;
    }
    setvalue(event.target.value)
    values.body = event.target.value
    setrows(currentRows < maxRows ? currentRows : maxRows)

  };
  const removeUploadedFile = index => {
    setFieldValue(
      'files',
      values.files.filter(el => el !== index)
    );
  };

  const handleCheckChange = event => {
    let { checked } = event.target;
    setFieldValue('public', !checked);
  };

  const classNames = [
    'disable-post-btn',
    lineValues !== '' && lineValues.trim() && 'add-post-save-button',
    values.files.length > 0 && 'add-post-save-button',
  ]
    .filter(e => e)
    .join(' ');

  useEffect(() => {
    if (status && status.success) {
      setTimeout(() => {
        history.push(PROFILE);
      }, 1000);
    }
  }, [status]);



  return (
    <div className={'col-12 col-md-6 px-3 py-4'} style={{ minHeight: '77vh' }}>
      <div className="add-post-container">
        <h1>{t('create_post')}</h1>
      </div>
      <div className="add-post-cont ">
        {status && status.success ? (
          <>
            <p className="text-success text-center" style={{ fontSize: '1.1rem' }}>
              {t('Post was successfully created.')}
            </p>
            <hr />
          </>
        ) : (
          <Form onSubmit={handleSubmit}>
            <div className="d-flex post-file-container flex-column">
              <Loader isLoadin={isSubmitting} height={226} size={60}>
                <Form.Group>
                  <div className="post-form-container">
                    <Form.Label className={values.body && 'filled'}>{t('text_about_post')}</Form.Label>
                    <FormControl
                      dir={typingDirection}
                      as="textarea"
                      type="text"
                      ref={ref}
                      id="text"
                      rows={rows}
                      maxLength={1000}
                      name="body"
                      className="post-form-add-text"
                      style={{ resize: 'none', border: 'none', padding: 0, margin: 0, color: '#fff' }}
                      value={lineValues}
                      onChange={(e) => handleChange && handleLineChange(e)}
                      isInvalid={touched.body && errors.body}
                    />
                    <Form.Control.Feedback type="invalid">{!!errors.body && errors.body}</Form.Control.Feedback>
                  </div>
                </Form.Group>
                <FileUpload
                  files={values.files}
                  handleChange={handleFileInputChange}
                  handleRemove={removeUploadedFile}
                />
                {errors.files && (
                  <Form.Control.Feedback type="invalid" className="d-block">
                    {errors.files}
                  </Form.Control.Feedback>
                )}

                <div className="buttons-wrapper add-post-footer">
                  <ButtonComponent
                    type={'button'}
                    btnText={t('cancel')}
                    transparent={false}
                    customClass={'add-post-cancel-button'}
                    textClassName={'add-post-cancel-text'}
                    onClick={() => history.push(ROOT)}
                  />
                  <ButtonComponent
                    type={'submit'}
                    isBold={true}
                    values={values}
                    btnText={t('post')}
                    transparent={false}
                    customClass={classNames}
                    textClassName={'add-post-save-text'}
                  />
                </div>
              </Loader>
            </div>
          </Form>
        )

        }
      </div>
    </div>
  );
};

export default AddPost;
